import {
  githubLink,
  isAuthorizedToSyncToGithub,
  isSyncToGithubEnabled,
  lastSynchedAt,
} from './lib/+state/github.selectors';

export { GithubSyncDialogFacade } from './lib/+state/github-sync-dialog/github-sync-dialog.facade';
export { GithubFacadeService } from './lib/+state/github.facade';
export { GITHUB_SYNC_DIALOG_TOKEN, GithubSyncDialog } from './lib/+state/github.types';
export { GithubDomainModule } from './lib/github-domain.module';
export { GithubSelectors };

const GithubSelectors = { githubLink, isAuthorizedToSyncToGithub, isSyncToGithubEnabled, lastSynchedAt };
